import { useIntl } from "react-intl";
import PropTypes from "prop-types";
import Lomake from "@/components/02-organisms/Lomake";
import { useChangeObjectsByAnchorWithoutUnderRemoval } from "@/stores/muutokset";
import tuva from "@/i18n/definitions/tuva";
import FormTitle from "@/components/00-atoms/FormTitle";
import { toLower } from "ramda";

const constants = {
  formLocation: ["tuva", "maaratVuodet"],
  mode: "modification"
};

const MaaratVuodet = ({
  code,
  eiNoudatetaMaaratVuodet,
  isPreviewModeOn,
  maaraykset,
  mode = constants.mode,
  rajoitteet,
  sectionId,
  title,
  parentKoulutusmuoto
}) => {
  const intl = useIntl();

  const [changeObjects] = useChangeObjectsByAnchorWithoutUnderRemoval({
    anchor: sectionId
  });

  if (eiNoudatetaMaaratVuodet) {
    return (
      <Lomake
        anchor={sectionId}
        changeObjects={changeObjects}
        code={code}
        data={{ maaraykset, rajoitteet }}
        formTitle={title}
        mode={mode}
        isPreviewModeOn={isPreviewModeOn}
        isRowExpanded={true}
        path={constants.formLocation}
        rowTitle={intl.formatMessage(tuva.maaratVuodetOtsikko2)}
        showCategoryTitles={true}></Lomake>
    );
  } else if (isPreviewModeOn) {
    return (
      <div>
        <FormTitle
          level={3}
          title={intl.formatMessage(tuva.maaratVuodetOtsikko2)}
        />
        <p>
          {intl.formatMessage(tuva.oppilasOpiskelijamaaratYmsMaaratysti, {
            koulutusmuoto: toLower(parentKoulutusmuoto.genetiivi)
          })}
        </p>
      </div>
    );
  }

  return null;
};

MaaratVuodet.propTypes = {
  code: PropTypes.string,
  eiNoudatetaMaaratVuodet: PropTypes.bool,
  isPreviewModeOn: PropTypes.bool,
  maaraykset: PropTypes.array,
  mode: PropTypes.string,
  rajoitteet: PropTypes.object,
  sectionId: PropTypes.string,
  title: PropTypes.string,
  parentKoulutusmuoto: PropTypes.object
};

export default MaaratVuodet;
